module.exports = __webpack_public_path__ + "static/media/corporate-hq-expansion.df5d3319.png";